import React, { useRef, useState, useEffect } from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import { Switch, Text } from 'tea-component';
import SelectMultiple from '@/pages/intelligence/pages/Compare/PcConsoleGames/components/SelectMultiple';
import CompareCore from '../../components/CompareCore';
import { generateMetrics } from '../../utils/dataSourcesMetrics';
import { PERIODS_METRICS_CONFIG, DEVICES_NAMES_MAPPING } from '../../constants';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { IFilter } from '@/pages/intelligence/types/pcConsoleCompare';
import type { ICompareCoreInstance } from '../../components/CompareCore/types';

const {
  PAGE_KEY,
  PAGE_NAME,
  ENTITY_TYPES,
  PERIODS,
  DATA_SOURCES_METRICS,
  DEVICES,
  DATE_TYPE,
  DATE_TYPES,
  VISUALIS_TOOLTIP_TITLE,
  PAGE_LOG_KEY,
} = PERIODS_METRICS_CONFIG.PHYSICAL_REVENUE;
const METRICS_OPTIONS = generateMetrics(DATA_SOURCES_METRICS);
const METRICS_VALUES = METRICS_OPTIONS?.map((metric) => metric?.value) || [];

const DEVICES_OPTIONS = DEVICES.map((item) => ({
  text: DEVICES_NAMES_MAPPING?.[item] || item || '',
  value: item,
}));

type IPhysicalRevenueProps = IBaseProps;

export default function PhysicalRevenue(props: IPhysicalRevenueProps) {
  const { style, className } = props;

  const { formatMessage } = useIntl();

  const compareCoreInstance = useRef<ICompareCoreInstance | null>(null);

  const [filter, setFilter] = useState<IFilter>({
    metrics: [...METRICS_VALUES],
    devices: [...DEVICES],
    // 是否开启Heat Map模式，展示各个阶段，各个指标的 最优指标值
    isHeatMap: false,
  });
  const handleDevicesChange = (payload: string[]) => {
    if (!compareCoreInstance.current) return;
    const filterTemp = {
      ...filter,
      devices: Array.isArray(payload) ? payload : [],
    };
    setFilter(filterTemp);
    compareCoreInstance.current?.updateCompareTableData({ filter: filterTemp });
    compareCoreInstance.current?.updateCompareTrendsData({ filter: filterTemp });
  };
  const handleIsHeatMapChange = (value: boolean) => {
    const filterTemp = {
      ...filter,
      isHeatMap: value,
    };
    setFilter(filterTemp);
  };

  /** 页面初始化逻辑，不带任何条件查询 对比结果数据 **/
  useEffect(() => {
    if (!compareCoreInstance.current) return;
    compareCoreInstance.current?.updateCompareTableData();
    compareCoreInstance.current?.updateCompareTrendsData();
  }, []);
  /** 页面初始化逻辑，不带任何条件查询 对比结果数据 **/

  return (
    <div
      style={style}
      className={classnames('dbi-pc-console-compare dbi-pc-console-compare-physical-revenue', className)}
    >
      {/* 筛选器 */}
      <div className="dbi-pc-console-compare_filter no-card">
        <div className="dbi-filter">
          <SelectMultiple
            className="dbi-pc-console-compare_filter-control-item search-item"
            label={formatMessage({ id: 'dbi_compare_label_device' })}
            style={{ marginRight: 20 }}
            options={DEVICES_OPTIONS}
            value={filter?.devices}
            onChange={handleDevicesChange}
          />
          <div className="search-item">
            <Switch
              className="dbi-pc-console-compare_switcher dbi-common-switcher"
              disabled={false}
              value={filter?.isHeatMap}
              onChange={handleIsHeatMapChange}
            >
              <Text>{formatMessage({ id: 'dbi_compare_heat_map' })}</Text>
            </Switch>
          </div>
        </div>
      </div>
      <CompareCore
        ref={compareCoreInstance}
        pageKey={PAGE_KEY}
        pageName={PAGE_NAME}
        entityTypes={ENTITY_TYPES}
        filter={filter}
        periods={PERIODS}
        devices={DEVICES}
        dateType={DATE_TYPE}
        dateTypes={DATE_TYPES}
        visualisTooltipTitle={VISUALIS_TOOLTIP_TITLE}
        pageLogKey={PAGE_LOG_KEY}
        isOnlySingleMetricLine={false}
        isShowTitleTips={true}
        titleTips={formatMessage({ id: 'dbi_compare_us_data_only_tips' })}
      />
    </div>
  );
}
